export default __webpack_public_path__ + "c7abed90be296146968b7fcfaf33f4f6.svg";